<template>
	<div class="email">
		<security-info />
		<input
			type="email"
			:placeholder="$t('input.placeholder.email')"
			:value="member_info.email_address"
			disabled
		/>
		<button class="button_bg_red mt_10" @click="sendVerificationCode">
			{{ $t('button.code') }}
		</button>
		<div v-if="token" class="mt_20">
			<div class="d_flex">
				<div class="timer">{{ time }}</div>
				<input
					type="text"
					:placeholder="$t('input.placeholder.code_request')"
					style="border-radius: 0 5px 5px 0"
				/>
			</div>
			<div class="link_code_send">
				<a class="fc_red" @click="sendVerificationCode">{{
					$t('merchant.email.link1')
				}}</a>
			</div>
			<button class="button_bg_red" @click="checkVerificationCode">
				{{ $t('button.code_check') }}
			</button>
		</div>
	</div>
</template>

<script>
import SecurityInfo from '@/components/Merchant/Certification/SecurityInfo';
import { mapGetters } from 'vuex';
import { createVerification, createVerificationToken } from '@/api/mail';
import { commonError } from '@/common/dialog';
export default {
	name: 'Email',
	components: { SecurityInfo },
	data() {
		return {
			token: null,
			timer: null,
			time: '05:00',
			time_remaining: 0,
		};
	},
	computed: {
		...mapGetters('auth', ['member_info']),
	},
	methods: {
		async sendVerificationCode() {
			const { token } = await createVerificationToken().catch(commonError);
			this.token = token;
			this.startTimer();
		},
		async checkVerificationCode() {
			const { token } = await createVerification({ token: token }).catch(
				commonError,
			);
			this.resetTimer();
		},
		startTimer() {
			clearInterval(this.timer);
			this.time_remaining = 300;
			this.timer = setInterval(() => {
				this.updateTimer();
			}, 1000);
		},
		resetTimer() {
			clearInterval(this.timer);
			this.token = null;
			this.time = '05:00';
		},
		updateTimer() {
			if (this.time_remaining === 0) return this.resetTimer();
			this.time_remaining--;
			const minute = '0' + Math.floor(this.time_remaining / 60);
			const seconds =
				this.time_remaining % 60 < 10
					? '0' + (this.time_remaining % 60)
					: this.time_remaining % 60;
			this.time = minute + ':' + seconds;
		},
	},
};
</script>
